import {
  EditTravelersTrackingProps,
  SelectedPriceFreezePurchaseProperties,
} from "@hopper-b2b/types";
import {
  ITrackingProperties,
  combineTrackingProperties,
  ITrackingPropertiesRequest,
  updateTrackingPropertiesRequest,
} from "@hopper-b2b/utilities";
import {
  AirPriceFreezeStateWithoutValue,
  AirPriceFreezeMachineStateWithoutValue,
} from "../types";
import { getPassengerCount, getPassengerMap } from "./passengers";
import { getFinalizedPriceFreeze } from "./priceFreeze";
import {
  getDefaultPriceFreezeOffer,
  getPriceFreezeOfferDataTrackingProperties,
  getSelectedOfferData,
} from "./priceFreezeOffer";
import { getFlightPricePerPax } from "./tripDetails";

export const changedPriceFreezeDurationPropertiesSelector = (
  state: AirPriceFreezeStateWithoutValue
): ITrackingPropertiesRequest => {
  const trackingProperties = getPriceFreezeOfferDataTrackingProperties(
    state
  ) as ITrackingProperties;
  const selectedOfferDataTrackingProperties = getSelectedOfferData(state)
    .trackingProperties as ITrackingProperties;

  return combineTrackingProperties([
    trackingProperties,
    selectedOfferDataTrackingProperties,
  ]);
};

export const priceFreezeReviewDetailsPropertiesSelector = (
  state: AirPriceFreezeStateWithoutValue
) => {
  const trackingProperties = getPriceFreezeOfferDataTrackingProperties(
    state
  ) as ITrackingProperties;

  return combineTrackingProperties([trackingProperties]);
};

export const selectedPriceFreezePurchasePropertiesSelector = (
  state: AirPriceFreezeMachineStateWithoutValue
): ITrackingPropertiesRequest => {
  const changedPriceFreezeDurationProperties =
    changedPriceFreezeDurationPropertiesSelector(state);

  const priceFreeze = getFinalizedPriceFreeze(state);

  return updateTrackingPropertiesRequest(
    changedPriceFreezeDurationProperties,
    [],
    {
      price_freeze_id: priceFreeze?.id,
    }
  );
};

export const editTravelerEventPropSelector = (
  state: AirPriceFreezeStateWithoutValue
): EditTravelersTrackingProps => {
  const passengerMap = getPassengerMap(state);
  return {
    success: true,
    price_freeze_pax_total: getPassengerCount(state),
    price_freeze_pax_adults: passengerMap.ADT ?? 0,
    price_freeze_pax_children: passengerMap.CNN ?? 0,
    price_freeze_pax_lap_infants: passengerMap.INF ?? 0,
    price_freeze_pax_seat_infants: passengerMap.INS ?? 0,
  };
};
